import React from 'react'
import PropTypes from 'prop-types'

import { ScreenHeader } from '../../../../../../components/generic'
import { groupChartData, filterMedications } from '../../EMARChart/utils'
import { EMARScreenEmptyState } from '../../components'
import MARChart from '../../EMARChart/EMARChart'

export default function EMARResidentPDF(props) {
  const {
    chartData = [],
    endDate,
    resident,
    residentName,
    startDate,
    testId
  } = props

  if (!chartData?.length)
    return <EMARScreenEmptyState resident={resident} testId={testId} />

  const filteredChartData = filterMedications(chartData, startDate, endDate)

  const groups = groupChartData(filteredChartData)

  return (
    <div
      style={styles.pdfWrapper}
      data-testid={testId ? `${testId}-emar-resident-pdf` : 'emar-resident-pdf'}
    >
      {groups.map((group, index) => (
        <div
          key={group[0].id}
          className="page-break-after"
          data-testid={
            testId ? `${testId}-pdf-page-${index}` : `pdf-page-${index}`
          }
        >
          <ScreenHeader
            title={`${residentName}'s eMar`}
            data-testid={
              testId ? `${testId}-pdf-header-${index}` : `pdf-header-${index}`
            }
          />
          <MARChart
            displayTableHeader={false}
            isPDF
            startDate={startDate}
            endDate={endDate}
            medications={group}
            rowDisplaySettings={{
              isMedLinkActive: true
            }}
            testId={testId}
          />
        </div>
      ))}
    </div>
  )
}

EMARResidentPDF.propTypes = {
  chartData: PropTypes.array.isRequired,
  endDate: PropTypes.object.isRequired,
  resident: PropTypes.object.isRequired,
  residentName: PropTypes.string.isRequired,
  startDate: PropTypes.object.isRequired,
  testId: PropTypes.string
}

const styles = {
  pdfWrapper: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: 1190,
    // height: '100vh',
    // maxWidth: '100vw',
    minHeight: 1480,
    zIndex: 1000,
    background: 'white',
    padding: '24px 28px'
  }
}
